import React, { Component } from 'react';
import { Menu, Icon, Container } from 'semantic-ui-react'
import './App.css';
import Routes from "./Routes.js";
import Login from "./containers/Login.js";
// import  { invokeApig } from "./libs/awsLib";
import { Link, withRouter } from "react-router-dom";
import { API } from "aws-amplify";
import ErrorPage from "./containers/ErrorPage"
import config from "./config";
import { invokeApig } from './libs/awsLib';
import { Auth } from "aws-amplify";
import Cookies from 'universal-cookie';
import Switch from "react-switch";


class App extends Component {

  constructor(props) {
    super(props);
  
    const cookies=new Cookies();
    const darkModeCookie=cookies.get('sgServe-darkmode');
    console.log(darkModeCookie);
    var darkMode=false;
    if (darkModeCookie==="true")
    darkMode=true;


    this.state = {
      isAuthenticated: false, 
      isAuthenticating: true,
      isAuthorised: true,         
      userid: null, 
      userName: "", 
      darkmode: darkMode
    };
  }

  async componentDidMount()
  {
    try {
      await Auth.currentSession();
      this.userHasAuthenticated(true);
    }
    catch(e) {
      console.log(e)
      this.setState({ isAuthenticating: false });
    }
    // this.setState({ isAuthenticating: false });
    
    
  }

  setDarkMode(darkMode)
  {
    this.setState({darkmode: darkMode});
    const cookies=new Cookies()
    cookies.set('sgServe-darkmode', darkMode, { path: '/' });
  }


  userHasAuthenticated = (authenticated) => {

    // get user details
    API.get('api', '/api/users/0', {response: true}).then((results)=>{
      if (results.data.applications.indexOf(config.applicationid)>-1)
      {
        this.setState({user: results.data, userid: results.data.id, userName: results.data.firstname + ' ' + results.data.lastname, isAuthenticated: true, isAuthorised: true, isAuthenticating: false})
      }
      else {this.setState({isAuthenticated: true, isAuthorised: false, isAuthenticating: false} )}
      }
      
    )
  }
  render() {
    const topLevelPath=window.location.pathname.split('/')[1]
    const versionRoute = "/info"

    return (
      !this.state.isAuthenticating 
      ?
      this.state.isAuthenticated
      ?
      this.state.isAuthorised  
      ?
      <div className={"App"+(this.state.darkmode  ? " darkmode": "")}> 
        <Menu secondary icon='labeled'>
        <img src={require('./images/Seaglass-logo-small.png')}/>
        <a className={"seaglassblue item"+(topLevelPath==='' ? " active" : "")} href='/'><i aria-hidden="true" className="home icon"></i>Home</a>
        <a className={"seaglassblue item"+(topLevelPath==='smartdevices' ? " active" : "")} href='/smartdevices'><i aria-hidden="true" className="disk icon"></i>Devices</a>
        <a className={"seaglassblue item"+(topLevelPath==='smartorchestrations' ? " active" : "")} href='/smartorchestrations'><i aria-hidden="true" className="cogs icon"></i>Orchestrations</a>
        {/* <a className={"seaglassblue item"+(topLevelPath==='messages' ? " active" : "")} href='/messages'><i aria-hidden="true" className="mail icon"></i>Messages</a> */}
        {(this.state.user.configureaccess.indexOf(7)>-1 || this.state.user.configureaccess.indexOf(8)>-1 || this.state.user.configureaccess.indexOf(9)>-1 || this.state.user.configureaccess.indexOf(10)>-1 || this.state.user.configureaccess.indexOf(11)>-1 ) && <a className={"seaglassblue item"+(topLevelPath==='configure' ? " active" : "")} href='/configure'><i aria-hidden="true" className="setting icon"></i>Configure</a>}
        <a className={"seaglassblue item"+(topLevelPath==='reports' ? " active" : "")} href='/reports'><i aria-hidden="true" className="chart line icon"></i>Reports</a>
        <div className="right menu">
        <a className="seaglassblue item"><table><tr><td><Icon size="large" name="sun"/></td><td>
          {/* <Checkbox checked={this.state.darkmode} onChange={(event, data)=>{this.setDarkMode(data.checked)}} toggle/> */}
        <Switch checked={this.state.darkmode} onChange={(checked)=>{this.setDarkMode(checked)}} checkedIcon={false} uncheckedIcon={false} height={20} width={45} onColor="#558A60"/>
          </td><td><Icon size="large" name="moon"/></td></tr></table></a>

          <a className="seaglassblue item"><i aria-hidden="true" className="user icon"></i>{this.state.userName}</a>
          <a className="seaglassblue item" onClick={()=>this.setState({isAuthenticated: false})}><i aria-hidden="true" className="close icon"/>Sign out</a>
        </div>

        </Menu>
{/* 
        <div className="ui blue inverted labeled icon menu">
          <img src={require('./images/logo blue.jpg')}/>
          <Link className="active item" to="/import"><i aria-hidden="true" className="upload icon"></i>Contract Import</Link>
          <Link className="active item" to="/contractreport"><i aria-hidden="true" className="handshake icon"></i>Contract Report</Link>
          <Link className="active item" to="/commissionreport"><i aria-hidden="true" className="pound icon"></i>Commission Report</Link>

          <div className="right menu">
          <a className="item"><i aria-hidden="true" className="user icon"></i>{this.state.userName}</a>
          <a className="item"><i aria-hidden="true" className="building icon"></i>{this.state.tpi.name}</a>
          <a className="item" onClick={()=>this.userHasAuthenticated(false)}><i aria-hidden="true" className="close icon"/>Sign out</a>
          </div>
        </div> */}

        
      <div className="appmain">
        {/* <Grid> */}

        <Routes user={this.state.user} darkmode={this.state.darkmode}/>
        {/* </Grid> */}
        </div>
        <div className="sgfooter" float="bottom">
          © {new Date().getFullYear()} Seaglass Cloud Technology Ltd
          <div className="sgfooterright">
            <Link to={versionRoute} class="sgfooteritem">{this.state.version}</Link>
            <div className="sgfooteritem">{config.supplierStage}</div>
          </div>
        </div>
        </div>
      : <ErrorPage visible={true} messageHeader={'Authorisation Failed'} messageDetail={'You are not authorised to use this applcation'}/>
      : <Login isAuthenticated={this.state.isAuthenticated} onSuccess={()=>this.userHasAuthenticated(true)} />
      : null
    );
  }
}

export default App;
